import { useEffect } from "react";
import { updateTemplatesOrderByModuleIdRequest } from "src/requests/modules/requestCreators";
import { RowKey } from "src/requests/table/types";
import { useDispatch } from "react-redux";
import {
  fetchTemplateMetadataForTemplateId,
  updateTemplatesOrder,
} from "../actions";
import { TemplateId } from "../../../globalTypes";
import fetchVisibleOverviewTemplatesMetadata from "../thunks/fetchVisibleOverviewTemplatesMetadata";
import fetchTemplateMetadataForTemplateIds from "../thunks/fetchTemplateMetadataForTemplateIds";
import { fetchAllTemplatesMetadata } from "../thunks";

export const useFetchTemplateMetadataFromIdCallback = () => {
  const dispatch = useDispatch();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return async (id?: TemplateId | null, rowKey?: RowKey): Promise<any> => {
    if (!id) return Promise.resolve();
    return dispatch(fetchTemplateMetadataForTemplateId(id, rowKey));
  };
};

export const useFetchAllTemplatesMetadata = () => {
  const dispatch = useDispatch();
  return async (): Promise<void> => {
    await dispatch(fetchAllTemplatesMetadata());
  };
};

export const useFetchVisibleOverviewTemplateMetadataCallback = () => {
  const dispatch = useDispatch();
  return async (): Promise<void> => {
    await dispatch(fetchVisibleOverviewTemplatesMetadata());
  };
};

export const useFetchMetadataOnceForTemplate = (templateId: TemplateId) => {
  const fetchTemplateMetadata = useFetchTemplateMetadataFromIdCallback();
  useEffect(() => {
    fetchTemplateMetadata(templateId);
  }, [templateId]); // eslint-disable-line
};

export const useFetchTemplateMetadataForTemplateIds = () => {
  const dispatch = useDispatch();
  return async (templateIds: number[]): Promise<void> => {
    await dispatch(fetchTemplateMetadataForTemplateIds(templateIds));
  };
};

type UpdateOrdersOfTemplatesForModule = (
  moduleId: number,
  templatesOrder: Record<number, number>
) => Promise<void>;
type UseUpdateOrdersOfTemplatesForModule =
  () => UpdateOrdersOfTemplatesForModule;

export const useUpdatedOrdersOfTemplatesForModule: UseUpdateOrdersOfTemplatesForModule =
  () => {
    const dispatch = useDispatch();
    const updateOrdersOfTemplatesForModule: UpdateOrdersOfTemplatesForModule =
      async (moduleId, templatesOrder) => {
        try {
          await updateTemplatesOrderByModuleIdRequest(moduleId, templatesOrder);
          dispatch(updateTemplatesOrder(templatesOrder));

          return Promise.resolve();
        } catch (_) {
          throw new Error(
            `Erorr during updating templates order for module ID ${moduleId}`
          );
        }
      };

    return updateOrdersOfTemplatesForModule;
  };
